import React, { forwardRef, useEffect, useState, useMemo } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { find } from 'lodash';
import { FieldTypes } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';
import { Form } from 'antd';

const ProbelyMappingForm = forwardRef(function ProbelyMappingForm(props, ref) {
  const [projects, setProjects] = useState(() => {
    if (props.record) {
      const { applicationId, applicationName } = props.record;
      return [{id: applicationId, name: applicationName}]
    }
    return [];
  });
  const [form] = Form.useForm();

  useEffect(() => {
    const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
    promise.then((response) => {
      const { projects } = response;
      setProjects(projects);
    }).catch(() => {
      message.error('Problem fetching applications');
    });

    return cancel;
  }, [props.loginConfigId,props.toolName]);

  const getExtraFieldsData = (config) => {
    const { applicationId } = config;
    const applicationName = find(projects, (obj) => obj.id === applicationId)?.name;

    return ({
      applicationId,
      applicationName,
    });
  }

  const extraFields = useMemo(() => ([
    {
      name: 'applicationId',
      colSpan: '12',
      type: FieldTypes.SELECT,
      label: 'Application Name',
      options: projects,
      required: true,
      props: {
        autoFocus: true
      }
    }
  ]), [projects]);

  return (
    <GenericMappingForm
      ref={ref}
      form={form}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      {...props}
    />
  )
})

export default ProbelyMappingForm;